import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb2d6c3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fifth" }
const _hoisted_2 = { class: "honor-container" }
const _hoisted_3 = { class: "last" }
const _hoisted_4 = { class: "honor-img animate__animated animate__slideInRight wow" }
const _hoisted_5 = { alt: "" }
const _hoisted_6 = {
  class: "honor-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "2s"
}
const _hoisted_7 = { alt: "" }
const _hoisted_8 = { class: "center" }
const _hoisted_9 = {
  class: "honor-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "0.5s"
}
const _hoisted_10 = { alt: "" }
const _hoisted_11 = {
  class: "honor-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "1.5s"
}
const _hoisted_12 = { alt: "" }
const _hoisted_13 = { class: "top" }
const _hoisted_14 = {
  class: "double-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "0.8s"
}
const _hoisted_15 = { alt: "" }
const _hoisted_16 = {
  class: "honor-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "1s"
}
const _hoisted_17 = { alt: "" }
const _hoisted_18 = { class: "reflection" }
const _hoisted_19 = { class: "last" }
const _hoisted_20 = { class: "honor-img animate__animated animate__slideInRight wow" }
const _hoisted_21 = { alt: "" }
const _hoisted_22 = {
  class: "honor-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "2s"
}
const _hoisted_23 = { alt: "" }
const _hoisted_24 = { class: "center" }
const _hoisted_25 = {
  class: "honor-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "0.5s"
}
const _hoisted_26 = { alt: "" }
const _hoisted_27 = {
  class: "honor-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "1.5s"
}
const _hoisted_28 = { alt: "" }
const _hoisted_29 = { class: "top" }
const _hoisted_30 = {
  class: "double-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "0.8s"
}
const _hoisted_31 = { alt: "" }
const _hoisted_32 = {
  class: "honor-img animate__animated animate__slideInRight wow",
  "data-wow-delay": "1s"
}
const _hoisted_33 = { alt: "" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))

import WOW from 'wowjs'
import { onMounted } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'FifthView',
  setup(__props) {

onMounted(async () => {
  new WOW.WOW({ live: false }).init()
});


return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
            [_directive_lazy, require('@/assets/honor1.jpg')]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
            [_directive_lazy, require('@/assets/honor5.jpg')]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
            [_directive_lazy, require('@/assets/honor2.jpg')]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
            [_directive_lazy, require('@/assets/honor4.jpg')]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
            [_directive_lazy, require('@/assets/honor6.jpg')]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
            [_directive_lazy, require('@/assets/honor3.jpg')]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
            [_directive_lazy, require('@/assets/honor1.jpg')]
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [
            [_directive_lazy, require('@/assets/honor5.jpg')]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _withDirectives(_createElementVNode("img", _hoisted_26, null, 512), [
            [_directive_lazy, require('@/assets/honor2.jpg')]
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _withDirectives(_createElementVNode("img", _hoisted_28, null, 512), [
            [_directive_lazy, require('@/assets/honor4.jpg')]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _withDirectives(_createElementVNode("img", _hoisted_31, null, 512), [
            [_directive_lazy, require('@/assets/honor6.jpg')]
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _withDirectives(_createElementVNode("img", _hoisted_33, null, 512), [
            [_directive_lazy, require('@/assets/honor3.jpg')]
          ])
        ])
      ])
    ]),
    _hoisted_34
  ]))
}
}

})